module.exports = {
  // The application name, to be used when asking the configuration system for settings
  appName: 'AssessmentsMleHost', // TODO: 1. Set this to the name of the host application
  // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them
  childApplications: ['user-feedback']
};
